const dictionary: { [key: string]: string } = {
  incomplete: 'Incomplete',
  pending_review: 'Pending Review',
  reviewed: 'Reviewed'
}

export const getQuarterlyReportStatusLabel = (name: string) => dictionary[name] || name
